import React from 'react';
import * as styles from './TagList.style';

export interface TagListProps {
  list: string[],
  inline?: boolean,
}

const TagList: React.FC<TagListProps> = ({
  list,
  inline,
}) => (
  <ul
    css={styles.list}
    $inline={inline}
  >
    {list.map((item) => (
      <li
        key={item}
        css={styles.item}
        data-ref="list-item"
      >
        <div css={styles.tag}>
          {item}
        </div>
      </li>
    ))}
  </ul>
);

export default TagList;
